<template>
  <form class="c-form-block-update-admin" @submit.prevent="onSubmit">
    <h5>Brand ID : {{ form.brandId }}</h5>
    <Form
      ref="form"
      :schema="schema"
      v-model="form"
      @status="saveStatus"
      buttonText="Update"
      :processing="processing"
      :errors="errors"
    ></Form>
  </form>
</template>

<script>
import Form from "./index.vue";

const schema = {
  rating: {
    component: "InputNumber",
    label: "Set Brand rating",
  },
};

export default {
  components: {
    Form,
  },

  data: function () {
    return {
      processing: false,
      currentForm: {},
      status: null,
      errors: [],
      form: {
        rating: 1,
        brandId: null,
      },
    };
  },

  props: {
    ad: {},
  },

  computed: {
    schema: function () {
      let s = schema;

      return s;
    },
  },

  methods: {
    reset: function () {},
    saveStatus: function (saveStatus) {
      this.status = saveStatus;
    },
    async onSubmit() {
      this.$refs.form.validate();

      if (this.status.invalid) {
        return;
      }

      this.processing = true;

      let form = this.form;

      console.log(form);

      let response = await this.$store.dispatch("ads/updateBrand", form).catch((err) => {
        console.log(err);
        this.$store.dispatch("message/onServerError");
      });

      this.processing = false;

      if (!response) {
        return;
      }

      this.$store.dispatch("message/onAdUpdate");

      this.$emit("onSubmit");
    },
  },

  created: function () {
    if (this.ad && this.ad.block) {
      this.form.brandId = this.ad.block.brandId;
    }
  },
};
</script>

<style></style>
